module.exports = __webpack_public_path__ + "img/8.1c0171f1.png";